var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.66667 12.6667C4.29934 12.6667 4.00001 12.3673 4.00001 12C4.00001 11.6327 4.29934 11.3333 4.66667 11.3333H12V12.6667H4.66667ZM4.66667 3.33333H12V10H4.66667C4.43134 10 4.20934 10.048 4.00001 10.1227V4C4.00001 3.63267 4.29934 3.33333 4.66667 3.33333ZM12.6667 2H4.66667C3.56401 2 2.66667 2.89733 2.66667 4V12C2.66667 13.1027 3.56401 14 4.66667 14H12H12.6667C13.0347 14 13.3333 13.7013 13.3333 13.3333V12.6667V11.3333V2.66667C13.3333 2.29867 13.0347 2 12.6667 2Z",
    fill: "#ABABAB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1651_6451",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 12,
    height: 12
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.66667 12.6667C4.29934 12.6667 4.00001 12.3673 4.00001 12C4.00001 11.6327 4.29934 11.3333 4.66667 11.3333H12V12.6667H4.66667ZM4.66667 3.33333H12V10H4.66667C4.43134 10 4.20934 10.048 4.00001 10.1227V4C4.00001 3.63267 4.29934 3.33333 4.66667 3.33333ZM12.6667 2H4.66667C3.56401 2 2.66667 2.89733 2.66667 4V12C2.66667 13.1027 3.56401 14 4.66667 14H12H12.6667C13.0347 14 13.3333 13.7013 13.3333 13.3333V12.6667V11.3333V2.66667C13.3333 2.29867 13.0347 2 12.6667 2Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1651_6451)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#ABABAB"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactIcon);
export default __webpack_public_path__ + "static/media/contact_icon.1d0dace06e5234316aeb453355834bb8.svg";
export { ForwardRef as ReactComponent };